import RectangleAd from '@components/Advertisements/RectangleAd';
import { ExplorerBoatsCarousel } from '@components/ExplorerBoatsCarousel';
import Jumbotron from '@components/Jumbotron';
import { Layout } from '@components/Layout';
import {
  IBoatActivitiesPageData,
  IBoatCategoriesPageData,
  IBoatsTypePageData,
  IHullTypePageData,
} from '@interfaces/pagesData';
import { fetchBoatsActivityPageData } from '@utils/fetchBoatsActivityPageData';
import { fetchBoatsCategoriesPageData } from '@utils/fetchBoatsCategoriesPageData';
import { fetchBoatsTypePageData } from '@utils/fetchBoatsTypePageData';
import { fetchHullTypePageData } from '@utils/fetchHullTypePageData';
import { FC } from 'react';
import { useSubscription } from 'services/hooks/queries/useSubscription';

interface Props {
  boatsTypeData: IBoatsTypePageData;
  categoriesData: IBoatCategoriesPageData;
  hullTypeBoatsData: IHullTypePageData;
  boatsActivityData: IBoatActivitiesPageData;
}

const ExploreBoatsPage: FC<Props> = ({ boatsActivityData, boatsTypeData, categoriesData, hullTypeBoatsData }) => {
  const title = 'Explorer all';

  const metaData = {
    title,
  };

  const { isSubscribed } = useSubscription();

  return (
    <Layout meta={metaData}>
      <main>
        <Jumbotron breadCrumb={[0]} pageName="explore_boats" title={title} desc="Love at first sail. Find it here!" />
        {!isSubscribed ? (
          <div style={{ padding: '0 24px' }}>
            <RectangleAd />
          </div>
        ) : null}

        {boatsActivityData.boatsActivities.map((typeData) => (
          <ExplorerBoatsCarousel
            key={typeData?.activity?.documentId}
            more={{ text: 'Explore all', url: `/boats/activity/${typeData.activity.slug}` }}
            title={typeData?.activity?.name}
            subtitle={'Explorer activity'}
            boats={typeData.boats}
          />
        ))}

        {boatsTypeData.boatsTypes.map((typeData) => (
          <ExplorerBoatsCarousel
            key={typeData.boatsType.documentId}
            more={{ text: 'Explore all', url: `/boats/type/${typeData.boatsType.slug}` }}
            title={typeData.boatsType.name}
            subtitle={'Explorer by boat type'}
            boats={typeData.boats}
          />
        ))}

        {categoriesData.boatsCategories.map((categoryData) => (
          <ExplorerBoatsCarousel
            key={categoryData.category.documentId}
            more={{ text: 'Explore all', url: `/boats/category/${categoryData.category.slug}` }}
            title={categoryData.category.name}
            subtitle={'Explorer by category'}
            boats={categoryData.boats}
          />
        ))}

        {hullTypeBoatsData.hullTypes.map((typeData) => (
          <ExplorerBoatsCarousel
            key={typeData.hullTypeBoats.documentId}
            more={{ text: 'Explore all', url: `/boats/hull-type/${typeData.hullTypeBoats.slug}` }}
            title={typeData.hullTypeBoats.name}
            subtitle={'Explorer by boat type'}
            boats={typeData.boats}
          />
        ))}
      </main>
    </Layout>
  );
};

export async function getStaticProps() {
  const categoriesData = await fetchBoatsCategoriesPageData(10);
  const hullTypeBoatsData = await fetchHullTypePageData(10);
  const boatsTypeData = await fetchBoatsTypePageData(10);
  const boatsActivityData = await fetchBoatsActivityPageData(10);

  return {
    props: {
      categoriesData,
      hullTypeBoatsData,
      boatsTypeData,
      boatsActivityData,
    },
  };
}

export default ExploreBoatsPage;
